// extracted by mini-css-extract-plugin
export default {"root":"IconChevronUp_root__xen7T"};